module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topics"
  }, [_c('div', {
    staticClass: "tab-nav"
  }, _vm._l((_vm.tabItem), function(item, index) {
    return _c('a', {
      staticClass: "btn",
      class: {
        'active': _vm.initIndex === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.changeTab(index, item.type)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('ul', {
    staticClass: "topics-list"
  }, _vm._l((_vm.topics), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "topic-man"
    }, [_c('img', {
      attrs: {
        "src": item.author.avatar_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "topic-desc"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.author.loginname)), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.last_reply_at)))])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [(item.top === true) ? _c('span', {
      staticClass: "type"
    }, [_vm._v("置顶")]) : _vm._e(), _vm._v(_vm._s(item.title) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "summary"
    }, [_c('span', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.tab || 'all'))]), _c('span', {
      staticClass: "comment"
    }, [_vm._v(_vm._s(item.reply_count))]), _c('span', {
      staticClass: "read"
    }, [_vm._v(_vm._s(item.visit_count))])])])])], 1)
  })), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "load-result"
  }, [_vm._v("已无更多数据")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-wrapper"
  }, [_c('loading')], 1), _vm._v(" "), _c('footer-section')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d969f26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/topics.vue
// module id = 42
// module chunks = 0